import React, { ReactNode } from 'react';
import classNames from 'classnames';
import styles from './PromotionBanner.module.scss';

export interface PromotionBannerProps {
  children: ReactNode;
  onClick?(): void;
  backgroundColor?: string;
}

const DEFAULT_BACKGROUND_COLOR = '#fdf1eb';

const PromotionBanner = ({
  children,
  onClick,
  backgroundColor = DEFAULT_BACKGROUND_COLOR,
}: PromotionBannerProps) => {
  const classes = classNames(styles.container, {
    [styles.clickable]: onClick,
  });

  return (
    <div
      className={classes}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      style={{ backgroundColor }}
    >
      {children}
    </div>
  );
};

export default PromotionBanner;
